module.exports = __webpack_public_path__ + "img/checkbox-checked.33d70b05.svg";